<template>
  <div class="mb-3">
    <label class="d-block">{{ $tc("custom_forms.check_facility_fields") }}</label>
    <div class="row mt-1">
      <div
        v-for="item in fields"
        :key="item.key"
        class="col-6 mb-1"
      >
        <b-form-checkbox v-model="extraFields[item.key]" switch @input="onInputChange">
          {{ $t(item.label) }}
        </b-form-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import {onMounted, ref} from '@vue/composition-api';

export default {
  components: {
  },
  props: {
    data: {
      type: Object,
      default: () => ({ data: [] }),
    },
    config: Object,
  },
  setup(props, {emit, root}) {
    const fields = [
      { key: "sirh", label: "custom_forms.sirh" },
      { key: "rems", label: "custom_forms.rems" },
      { key: "categories", label: "custom_forms.categories" },
      { key: "region", label: "custom_forms.region_field" },
      { key: "municipality", label: "custom_forms.municipality" },
      { key: "subregion", label: "custom_forms.subregion" },
      { key: "id_seproban", label: "custom_forms.id_seproban" },
      { key: "lat", label: "custom_forms.lat" },
      { key: "lng", label: "custom_forms.lng" },
      { key: "excluded_atms", label: "custom_forms.excluded_atms" },
    ]
    const extraFields = ref({
      categories: true,
      region: true,
      subregion: true,
      sirh: true,
      municipality: true,
      rems: true,
      id_seproban: true,
    })

    onMounted(async () => {
      extraFields.value = props.data?.data?.[0] ?? extraFields.value
      onInputChange()
    });

    function onInputChange() {
      emit("update:data", {
        data: [extraFields.value]
      });
    }

    return {
      fields,
      extraFields,
      onInputChange,
    };
  },
};
</script>
